import BaseTitleIcon from '@/components/PHR/BaseTitleIcon';
import constants from '@/constants';
import emrTypeHelper from '@/helper/emrType';
import { TYPE_POST_MESSAGE } from '@/hooks/useMessageWebview';
import FormListMobile from '@/screens/PHRMobile/MedicalRecordsDetail/FormListMobile';
import utils from '@/utils';
import { Checkbox, Col, Form, Segmented } from 'antd';
import dayjs from 'dayjs';
import _ from 'lodash';
import * as React from 'react';

export interface IMedicalRecordsDetailRowProps {
  emrType?: IEMRType;
  fields?: IFieldConfig[];
  groupKey?: string;
  listField?: any;
  parentNames?: any[];
  disabled?: boolean;
  isFirst?: boolean;
}

const isValidConfig = (config: any): config is IEMRType => {
  return config && typeof config === 'object' && 'fields' in config;
};

const MedicalRecordsDetailRow: React.FC<IMedicalRecordsDetailRowProps> = ({
  emrType,
  fields,
  groupKey,
  disabled,
  parentNames = ['data'],
  isFirst = false,
}) => {
  // const form = Form.useFormInstance();
  //   const formValues = form.getFieldsValue();
  //   const allFieldsHaveValue = Object.values(formValues).every((value) => value !== undefined);
  const [tab, setTab] = React.useState<string>(emrType?.extra?.formDetail?.tabs?.[0]?.key || '');
  const fieldsAndGroups = emrType?.extra?.formDetail?.tabs?.find((d) => d.key === tab)?.fieldsAndGroups;

  return (
    <>
      {/* Tạo group */}
      {disabled && emrType?.extra?.formDetail?.type === 'tab' && (
        <div className="sticky top-0 left-0 w-full z-10 bg-quick-modal ">
          <Segmented
            options={
              emrType?.extra?.formDetail?.tabs?.map((d) => ({
                key: d.key,
                value: d.key,
                label: <span className="text-md">{d.name}</span>,
              })) || []
            }
            block
            size="middle"
            value={tab}
            onChange={(value) => {
              setTab(value);
            }}
          />
        </div>
      )}
      <div className={`${isFirst ? 'shadow-lg bg-gray-1 p-4 rounded-2xl my-4' : ''}`}>
        {emrType?.groups?.map((g, i) => {
          if (disabled && _.isArray(fieldsAndGroups) && !fieldsAndGroups.includes(g.key)) {
            return <React.Fragment key={i.toString()}></React.Fragment>;
          }

          const listFieldInGroup = emrType.format.fields?.filter((f) => f.group === g.key);

          return (
            <React.Fragment key={i.toString()}>
              {g.name && listFieldInGroup.length ? (
                <Col span={24}>
                  <BaseTitleIcon src={g.icon} title={g.name} className="" />
                </Col>
              ) : (
                ''
              )}
              <MedicalRecordsDetailRow
                disabled={disabled}
                fields={listFieldInGroup}
                groupKey={g.key}
                parentNames={parentNames}
                isFirst={false}
              />
            </React.Fragment>
          );
        })}

        {/* Tạo Field */}
        {fields?.map((f: IFieldConfig, i: number) => {
          // Nếu có trong group thì sẽ render ở group
          if (f.group && !groupKey) {
            return '';
          }

          // Nếu đặt config dạng tab mà nằm ngoài tab thì ko hiển thị
          if (
            disabled &&
            _.isArray(fieldsAndGroups) &&
            !(fieldsAndGroups.includes(f.group) || fieldsAndGroups.includes(f.key))
          ) {
            return <React.Fragment key={i.toString()}></React.Fragment>;
          }

          // Nếu có chưa sub thì sẽ render sub
          if (f?.emr && isValidConfig(f.emr)) {
            // Nếu là dạng multiple sẽ có add nhiều phần
            return (
              <FormListMobile
                key={i.toString()}
                disabled={!!disabled}
                fieldConfig={f}
                parentNames={[...parentNames, f.key]}
              />
            );
          }
          const names = [...parentNames, f.key];
          // const value = form.getFieldValue(names)
          // if (!value && value !== 0) return <></>
          // Bắt đầu tạo field ở đây
          return (
            <Form.Item className="mb-2" key={i.toString()} name={names}>
              <FieldMobile field={f} />
            </Form.Item>
          ); //<FieldCondition disabled={disabled} key={i} field={f} parentNames={[...parentNames]} />;
        })}
      </div>
    </>
  );
};

export default MedicalRecordsDetailRow;

const FieldMobile = ({
  field,
  id,
  value,
  name,
  ...props
}: {
  value?: any;
  id?: string;
  field: IFieldConfig;
  name?: string[];
}) => {
  const Swap = ({ children }: any) => {
    return (
      <div
        className="flex justify-between flex-wrap"
        onClick={() => {
          console.log('value', field.inputType, value);
        }}
      >
        <div className="font-bold">{field.label}: </div>
        {children}
      </div>
    );
  };

  switch (field.inputType) {
    case 'selectKey':
      return (
        <Swap>
          <div>{value?.label || '--'}</div>
        </Swap>
      );

    case 'select':
      const option = emrTypeHelper.getOption(field, value);
      return <Swap>{option ? <b style={{ color: option.color }}>{option.label}</b> : '--'}</Swap>;
    case 'time':
    case 'date':
      return (
        <Swap>
          <div>{value ? dayjs(value).format(field.extra.format || constants.DATE_FORMAT) : ''}</div>
        </Swap>
      );
    case 'file':
      return (
        <Swap>
          <div className="w-full flex flex-wrap mt-2">
            {utils.parseLinks(value).map((l, i: number) => {
              return (
                <button
                  className="max-w-full break-words block text-right w-full bg-transparent text-blue-9 mb-1"
                  key={i.toString()}
                  onClick={() => {
                    const url = l?.url ?? '';
                    const urlHandle = url?.toLocaleLowerCase().includes('.dcm')
                      ? `https://dicom-viewer.pta.com.vn/?input=${url}`
                      : url;
                    utils.postMessage({
                      type: TYPE_POST_MESSAGE.VIEW_FILE,
                      data: {
                        ...l,
                        url: urlHandle,
                        fullName: l.fullName,
                        name: l.name,
                        extension: l.extension,
                      },
                    });
                  }}
                >
                  {l.fullName}
                </button>
              );
            })}
          </div>
        </Swap>
      );
    case 'tag':
      return (
        <Swap>
          <div>{field.inputType}</div>
        </Swap>
      );
    case 'radio':
      return (
        <Swap>
          <div>-</div>
        </Swap>
      );
    case 'checkbox':
      return (
        <Swap>
          <Checkbox checked={value} disabled />
        </Swap>
      );
    case 'longText':
    case 'hidden':
    case 'number':
    default:
      return (
        <Swap>
          <div
            dangerouslySetInnerHTML={{
              __html: `${['string', 'number'].includes(field.type) ? value ?? '' : field.type} <b>${field.unit}</b>`,
            }}
            style={{
              whiteSpace: 'pre-line',
            }}
          />
        </Swap>
      );
  }
};

// const renderValue = () => {
//   switch (field.inputType) {
//     case 'selectKey':
//       return <EmrSearch {...defaultProps} />;
//     case 'number':
//       return <EmrInputNumber {...defaultProps} />;
//     case 'select':
//       return <EmrSelect {...defaultProps} />;
//     case 'longText':
//       return <EmrLongText {...defaultProps} />;
//     case 'date':
//       return <EmrDate {...defaultProps} />;
//     case 'time':
//       return <EmrTime {...defaultProps} />;
//     case 'file':
//       return <EmrFile {...defaultProps} />;
//     case 'tag':
//       return <EmrTag {...defaultProps} />;
//     case 'radio':
//       return <EmrRadio {...defaultProps} />;
//     case 'checkbox':
//       return <EmrCheckbox {...defaultProps} />;
//     default:
//       return <EmrInput {...defaultProps} />;
//   }
// };
